const LANGUAGE_PRIORITY: readonly string[] = [
  'javascript',
  'typescript',
  'ts',
  'csharp',
  'cs',
  'fsharp',
  'fs',
  'python',
  'py',
  'go',
  'java',
  'kotlin',
  'swift',
  'rust',
  'cpp',
  'c',
]

function pickDefaultLanguage(languageKeys: string[]): string {
  const set = new Set(languageKeys.map((k) => k.toLowerCase()))
  for (const candidate of LANGUAGE_PRIORITY) {
    if (set.has(candidate)) return candidate
  }
  return [...languageKeys].toSorted((a, b) => a.localeCompare(b))[0] ?? 'default'
}

export type QuickStartArticleLinkSection = {
  path: string
  languages?: string[]
  defaultLanguage?: string
}

function stripNumericPrefix(path: string): string {
  return path
    .split('/')
    .filter(Boolean)
    .map((segment) => segment.replace(/^\d+[-_]/, ''))
    .join('/')
}

/**
 * Relative URL path under `/quick-start` (no leading slash), matching Academy routing.
 * Numeric order prefixes are stripped from each segment (e.g. "2-expose-backend" → "expose-backend").
 */
export function buildQuickStartArticleUrlPath(section: QuickStartArticleLinkSection): string {
  const langs =
    section.languages && section.languages.length > 0 ? section.languages : [section.defaultLanguage ?? 'default']
  const pathParts = stripNumericPrefix(section.path).split('/').filter(Boolean)
  if (langs.length === 1) {
    return pathParts.join('/')
  }
  const lang = section.defaultLanguage ?? pickDefaultLanguage(langs)
  return `${pathParts.join('/')}/${lang}`
}
